import React, { useContext } from 'react';
import { ApplicationUIContext, SectionTitle, Form, useDrawerState } from '@yuhuinc/ui-library';
import { ContentWrapper } from '../common/StyledComponents';
import { getTranslatedString } from 'helpers/i18n';
import { Button, Space } from 'antd';
import BenefitDrawer from './BenefitDrawer';
import BenefitTable from './BenefitTable';

const atLeastOneBenefitRule = {
  required: true,
  message: getTranslatedString('landlordPortal.incentives.atLeastOneBenefit'),
};

const Benefits = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [, addBenefitDrawer] = useDrawerState(false);

  return (
    <ContentWrapper>
      <SectionTitle>{getTranslatedString('landlordPortal.incentives.benefits')}</SectionTitle>

      <Form.List name="benefits" rules={[atLeastOneBenefitRule]}>
        {(fields, operations, { errors }) => {
          const addBenefit = (benefit) => operations.add(benefit);

          return (
            <Space direction="vertical" size="middle">
              {fields.length > 0 && <BenefitTable benefits={fields} operations={operations} />}

              <div>
                <Button size={isMobile && 'large'} onClick={addBenefitDrawer.open} disabled={false}>
                  {getTranslatedString('landlordPortal.incentives.addABenefit')}
                </Button>
              </div>

              <Form.ErrorList errors={errors} />

              <BenefitDrawer mode="create" drawer={addBenefitDrawer} addBenefit={addBenefit} />
            </Space>
          );
        }}
      </Form.List>
    </ContentWrapper>
  );
};

export default Benefits;
